export const canvasSave = (canvas) => {
  return {
    ...canvas,
    selectedObject: null,
    objectsBeforeSave: canvas.objects
  }
}
